export const rabbySvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Rabby Wallet Logo"
  >
    <title>Rabby Wallet Logo</title>
    <rect width="12" height="12" rx="3" fill="#EBEDFB" />
    <g transform="translate(0, 0.5) scale(1.1)">
      <path
        d="M9.5721 5.7499C9.8866 5.0840 8.1892 3.2154 6.6954 2.3823C5.7598 1.7563 4.7717 1.8401 4.5853 2.1245C4.1549 2.7226 6.0967 3.2520 7.3950 3.8558C7.1472 3.9764 6.8946 4.1838 6.7517 4.4371C6.2874 3.9280 5.2613 3.5014 4.1590 3.8558C3.4854 4.1008 2.7626 4.6852 2.5094 5.5135C2.4467 5.4869 2.3767 5.4710 2.2998 5.4710C2.0064 5.4710 1.7717 5.7096 1.7717 6.0073C1.7717 6.3050 2.0064 6.5436 2.2998 6.5436C2.3507 6.5436 2.5170 6.5076 2.5170 6.5076L4.7717 6.5245C3.9726 8.2040 3.2103 8.4080 3.2103 8.6630C3.2103 8.9180 3.9180 8.8361 4.2186 8.7263C5.7352 8.2146 7.0660 6.6879 7.2942 6.2246C8.3475 6.3688 9.2166 6.3847 9.5721 5.7499Z"
        fill="#8697FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3944 3.8557C7.3945 3.8557 7.3946 3.8558 7.3947 3.8558C7.4548 3.8352 7.4461 3.7506 7.4322 3.6805C7.3994 3.5201 6.7746 2.9261 6.2170 2.6612C5.5215 2.2965 4.9374 2.3152 4.8514 2.4833C4.9937 2.8066 5.7640 3.1063 6.5395 3.4180C6.8882 3.5549 7.2351 3.6939 7.3944 3.8557C7.3944 3.8558 7.3944 3.8558 7.3944 3.8557Z"
        fill="#8697FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.2552 7.0712C6.0818 7.0112 5.8933 6.9557 5.6818 6.9061C5.9029 6.5393 5.9510 5.9690 5.7525 5.6028C5.4532 5.1042 5.0556 4.8282 4.2115 4.8282C3.7200 4.8282 2.4599 4.9821 2.4356 6.0102C2.4331 6.1179 2.4356 6.2153 2.4439 6.3080L4.7714 6.5241C4.4672 6.7734 4.1652 7.1284 3.9000 7.4078C4.2305 7.4836 4.4899 7.5487 4.6998 7.6068C4.8768 7.6612 5.0481 7.7126 5.2313 7.7649C5.5162 7.5397 5.8350 7.3024 6.2552 7.0712Z"
        fill="#465EED"
      />
      <path
        d="M2.3571 6.1987C2.4479 6.9744 2.9092 7.2696 3.8618 7.3599C4.8144 7.4503 5.3088 7.3884 5.9936 7.4515C6.5898 7.5047 7.0868 7.7870 7.2760 7.6875C7.4406 7.5982 7.3425 7.2733 7.1116 7.0716C6.8062 6.7917 6.4008 6.6022 5.6997 6.5353C5.8437 6.1454 5.8044 5.5937 5.6040 5.2915C5.3096 4.8564 4.7516 4.6586 3.9000 4.7439C3.2649 4.8316 2.6828 5.2346 2.3571 6.1987Z"
        fill="#6277F1"
      />
    </g>
  </svg>
);
